import React, { useEffect } from 'react';
import SplashTables from '../../assets/splashTables.png'
import { Container, Button, Grid, Typography, CircularProgress, Paper, TextField, Snackbar } from '@material-ui/core';

import firebase from 'firebase/compat/app'
import 'firebase/compat/database';

import Alert from '@material-ui/lab/Alert';

function Administration(props) {

    const [urls, setUrls] = React.useState({})
    const [loading, setLoading] = React.useState(true)
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        firebase.database().ref('urlsInfo').once("value", (snapshot) => {
            let newval = snapshot.val()
            setUrls(newval)
            setLoading(false)
        })
    }, [])

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setUrls({
            ...urls,
            [name]: value,
        });
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const saveChanges = () => {
        firebase.database().ref('urlsInfo').set(urls);
        setOpen(true);
    }

    return (
        <div>
            <div style={{ position: "absolute", top: 115, left: 0 }}>
                <img src={SplashTables} style={{ height: 115, width: '100%' }} alt="Logo" />
            </div>
            <Container>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", height: 115 }}>
                    <div style={{ zIndex: 1 }}>
                        <p color="#000000" style={{ fontSize: 28, marginTop: 10, marginBottom: 10 }}>Administración</p>
                    </div>
                </div>
            </Container>
            {loading ?
                <Container style={{ alignItems: "center" }}>
                    <CircularProgress style={{ marginTop: 10, marginBottom: 10 }} color="secondary" />
                </Container>
                :
                <Container maxWidth="lg" style={{ paddingTop: 10 }} >
                    <Paper elevation={2} style={{ padding: 10 }}>
                        <Typography style={{ fontSize: 20, fontWeight: 500 }}>
                            Accesos
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Lusqtoff
                                </Typography>
                                <TextField value={urls.lplusqtoff} fullWidth onChange={handleFieldChange} name="lplusqtoff" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Trupper
                                </Typography>
                                <TextField value={urls.lptrupper} fullWidth onChange={handleFieldChange} name="lptrupper" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Accessorios
                                </Typography>
                                <TextField value={urls.accesorios} fullWidth onChange={handleFieldChange} name="accesorios" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Catalogos
                                </Typography>
                                <TextField value={urls.catalogos} fullWidth onChange={handleFieldChange} name="catalogos" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Garantías
                                </Typography>
                                <TextField value={urls.garantias} fullWidth onChange={handleFieldChange} name="garantias" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Banco de imágenes
                                </Typography>
                                <TextField value={urls.images} fullWidth onChange={handleFieldChange} name="images" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Repuestos
                                </Typography>
                                <TextField value={urls.repuestos} fullWidth onChange={handleFieldChange} name="repuestos" />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} spacing={3} >
                                <Typography style={{ fontSize: 16, fontWeight: 500 }}>
                                    Services
                                </Typography>
                                <TextField value={urls.services} fullWidth onChange={handleFieldChange} name="services" />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: 20, textAlign: 'end' }} >
                            <Button style={{ borderRadius: 30 }} onClick={saveChanges} variant="contained" component="span" color="secondary">Guardar</Button>
                        </Grid>
                    </Paper>
                    <Snackbar open={open} autoHideDuration={1700} onClose={handleClose}>
                        <Alert onClose={handleClose} severity="success">
                            Los cambios se guardaron correctamente!
                        </Alert>
                    </Snackbar>
                </Container>
            }
        </div>
    )
}
export default Administration